module.exports = __webpack_public_path__ + "4af5b0e85b56060177ef8a6a83bb288f.pdf";